import React from "react";
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from "semantic-ui-react";
import { useEffect } from "react";
import SessionsDetails from "../shared/SessionsDetails";
import useSessionModal from "../hooks/useSessionModal";
import Flex from "../shared/Flex";
import SessionModalAction from "@common/redux/actions/SessionModalAction";
import {
  handleRowClickOptionChange,
  handleSessionsRowClick,
} from "../helpers/Sessions/sessionsDetailsHelpers";

const SessionModal = () => {
  const {
    grid,
    periodType,
    pageNumber,
    includeNonAlerts,
    open,
    sessionGuids,
    fetchAlertSessions,
  } = useSessionModal();

  useEffect(() => {
    if (open) fetchAlertSessions(null, sessionGuids);
  }, [open, periodType, includeNonAlerts, pageNumber]);

  return (
    <Modal
      open={open}
      closeIcon
      size="large"
      onClose={() => SessionModalAction.onClose(false)}
    >
      <ModalHeader>Select Session</ModalHeader>
      <ModalContent className="h-800">
        {grid ? (
          <Flex>
            <SessionsDetails
              displayPositions={false}
              showAlertFilter={true}
              hideShowEvents={true}
              onDetailClick={(row) => {
                const newGridData = handleRowClickOptionChange(grid.data, row);
                handleSessionsRowClick(row, newGridData);
              }}
              shortTerm={true}
            />
          </Flex>
        ) : (
          <></>
        )}
      </ModalContent>
      <ModalActions>
        <Button
          content="Back"
          floated="left"
          onClick={() => SessionModalAction.onClose(false)}
        />
        <Button
          content="Select"
          labelPosition="right"
          icon="checkmark"
          onClick={() => SessionModalAction.onClose(true)}
          positive
        />
      </ModalActions>
    </Modal>
  );
};

export default SessionModal;
